var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "#A9B0B8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 27.75C11.2805 27.75 8.62209 26.9436 6.36091 25.4327C4.09974 23.9218 2.33737 21.7744 1.29666 19.2619C0.255958 16.7494 -0.0163381 13.9847 0.514208 11.3175C1.04476 8.65027 2.35432 6.20026 4.27729 4.27729C6.20026 2.35432 8.65027 1.04476 11.3175 0.514208C13.9847 -0.0163381 16.7494 0.255958 19.2619 1.29666C21.7744 2.33737 23.9218 4.09974 25.4327 6.36091C26.9436 8.62209 27.75 11.2805 27.75 14C27.75 17.6467 26.3013 21.1441 23.7227 23.7227C21.1441 26.3013 17.6467 27.75 14 27.75ZM14 2.75001C11.775 2.75001 9.59989 3.40981 7.74984 4.64597C5.89979 5.88214 4.45785 7.63915 3.60636 9.69481C2.75488 11.7505 2.53209 14.0125 2.96617 16.1948C3.40025 18.3771 4.47171 20.3816 6.04505 21.955C7.61839 23.5283 9.62295 24.5998 11.8052 25.0338C13.9875 25.4679 16.2495 25.2451 18.3052 24.3936C20.3609 23.5422 22.1179 22.1002 23.354 20.2502C24.5902 18.4001 25.25 16.225 25.25 14C25.25 11.0163 24.0647 8.15484 21.955 6.04505C19.8452 3.93527 16.9837 2.75001 14 2.75001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.248 12.7495H15.248V7.74951H12.748V12.7495H7.74805V15.2495H12.748V20.2495H15.248V15.2495H20.248V12.7495Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.7b778524.svg";
export { ForwardRef as ReactComponent };